import React, { useCallback, useEffect, useState } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from 'js/store/hooks';
import { Link } from 'js/components/common/Link';
import { storageService } from 'js/services/storage.service';

import { IS_USER_SIGN_IN_STORAGE_KEY } from './constants';

import style from './SignInNotificationBanner.scss';

export const SignInNotificationBanner = () => {
    const [isVisible, setIsVisible] = useState(false);
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const translate = useTranslations('playtech.mobile.system.message.signInNotification.');
    const message = translate('message');
    const [messagePart1, messagePart2] = message.split('{0}');

    useEffect(() => {
        if (isLoggedIn) {
            storageService.local.setItem(IS_USER_SIGN_IN_STORAGE_KEY, true);

            setIsVisible(false);
        } else {
            storageService.local.removeItem(IS_USER_SIGN_IN_STORAGE_KEY);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        const onStorageChange = (event: StorageEvent): void => {
            const { key, newValue } = event;

            if (key !== IS_USER_SIGN_IN_STORAGE_KEY) {
                return;
            }

            setIsVisible(Boolean(newValue && !isLoggedIn));
        };

        window.addEventListener('storage', onStorageChange);

        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, [isLoggedIn]);

    const reload = useCallback((event: React.MouseEvent<HTMLAnchorElement>): void => {
        event.preventDefault();
        window.location.reload();
    }, []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className={`${style.container} cms-sign-in-notification-banner`}>
            <span>
                {messagePart1}
                <Link href="#" className={style.link} onClick={reload}>
                    {translate('linkText')}
                </Link>
                {messagePart2}
            </span>
        </div>
    );
};
